import Configuration from '@/agilis/util/Configuration'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import UnStyledLink from '@/agilis/components/UnstyledLink/UnstyledLink.vue'

export default {
  name: 'TrackerDataTableItemTitle',

  components: {
    UnStyledLink
  },

  props: {
    propDTO: Object,
    configuration: {
      type: Object
    }
  },

  data () {
    return {
      breadcrumbs: []
    }
  },

  mounted () {
    this.fetchParents()
  },

  computed: {
    ...mapGetters({
      selectedContext: 'contextStore/selectedContext',
      applicationId: 'contextStore/applicationId',
      workspaceId: 'contextStore/workspaceId',
      trackerTypeId: 'contextStore/trackerTypeId',
      trackerType: 'contextStore/trackerType',
      trackerTypes: 'contextStore/trackerTypes',
      mode: 'contextStore/contextMode',
      trackerId: 'contextStore/trackerId'
    }),

    computedTitle () {
      if (this.configuration?.itemTitle) {
        return this.$t(this.configuration.itemTitle, this.propDTO)
      }

      if (this.trackerType?.name) {
        return this.$t(this.trackerType?.name) + ' ' + this.propDTO.id
      }

      return this.trackerTypeId + ' ' + this.propDTO.id
    },

    computedSubTitle () {
      if (this.configuration?.itemSubtitle) {
        return this.$t(this.configuration.itemSubtitle, this.propDTO)
      }

      return this.propDTO.title
    },

    computedBreadcrumbs () {
      let breadcrumbs = []
      if (this.breadcrumbs && this.breadcrumbs.length > 1) {
        breadcrumbs = this.breadcrumbs.slice()
        let currentTracker = breadcrumbs.pop()
        currentTracker.text = this.computedTitle
        breadcrumbs.push(currentTracker)
      }
      return breadcrumbs
    }
  },

  methods: {
    ...mapActions({
      'notifyError': 'notificationStore/notifyError'
    }),

    fetchParents () {
      if (this.applicationId && this.trackerTypeId && this.trackerId) {
        const url = Vue.axios.agilisUrlTrackerParents(
          this.applicationId,
          this.trackerTypeId,
          this.trackerId)
        Vue.axios
          .get(
            url,
            Vue.axios.agilisRequestConfig(url))
          .then(async (response) => {
            if (response.data?.parentTracker) {
              this.breadcrumbs = await this.decorateBreadcrumbs(response.data, [])
            }
          })
          .catch((error) => {
            this.notifyError(error)
          })
      }
    },

    async decorateBreadcrumbs (data, breadcrumbs) {
      const isCurrentTracker = breadcrumbs.length === 0
      const breadcrumb = {
        disabled: (isCurrentTracker || this.userCanAccessTracker(data.tracker.trackerTypeId)),
        text: isCurrentTracker ? this.computedTitle : await this.breadcrumbText(data.tracker),
        selectedContext: Object.assign({}, this.selectedContext, { trackerId: data.tracker.id, trackerTypeId: data.tracker.trackerTypeId })
      }
      breadcrumbs.unshift(breadcrumb)

      if (data.parentTracker) {
        await this.decorateBreadcrumbs(data.parentTracker, breadcrumbs)
      }
      return breadcrumbs
    },

    handleBreadcrumbClick (breadcrumb) {
      this.$emit('click-breadcrumb', breadcrumb)
    },

    async fetchFullTracker (tracker) {
      let fullTracker = null
      const url = this.$axios.agilisUrlTrackerEdit(this.applicationId, tracker.trackerTypeId, tracker.id)
      const config = this.$axios.agilisRequestConfig(url)
      try {
        const response = await this.$axios.get(url, config)
        fullTracker = response.data
      } catch (error) {
        if (error?.response?.status !== 401) this.notifyError(error)
      }
      return fullTracker
    },

    async breadcrumbText (tracker) {
      let text = ''
      const trackerConfig = Configuration.getTrackerType(this.applicationId, tracker.trackerTypeId)
      let fullTracker = null
      if (trackerConfig?.dataTable?.itemSubtitle || (!tracker.title && trackerConfig?.dataTable?.itemTitle)) {
        fullTracker = await this.fetchFullTracker(tracker)
      }

      if (trackerConfig?.dataTable?.itemSubtitle && fullTracker) text = this.$t(trackerConfig.dataTable.itemSubtitle, fullTracker)
      else if (tracker?.title) text = tracker.title
      else if (trackerConfig?.dataTable?.itemTitle && fullTracker) text = this.$t(trackerConfig.dataTable.itemTitle, fullTracker)
      else if (trackerConfig?.name) text = `${this.$t(trackerConfig.name)} ${tracker.id}`
      else text = `${tracker.trackerTypeId} ${tracker.id}`
      return text
    },

    userCanAccessTracker (trackerTypeId) {
      if (!this.trackerTypes[trackerTypeId]) {
        return true
      }
      return false
    }
  }
}
